import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-68460b17")

_pushScopeId("data-v-68460b17")
const _hoisted_1 = { class: "shell" }
const _hoisted_2 = { class: "display-flex" }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = { class: "search-form-item" }
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = { class: "search-form-item" }
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "search-form-item" }
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = { class: "search-form-item" }
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = { class: "search-form-item" }
const _hoisted_13 = { class: "form-label" }
const _hoisted_14 = { class: "search-form-item" }
const _hoisted_15 = { class: "search-form-item" }
const _hoisted_16 = { class: "form-label" }
const _hoisted_17 = { class: "search-form-item" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = { class: "search-form-item" }
const _hoisted_20 = { class: "form-label" }
const _hoisted_21 = { class: "search-form-item" }
const _hoisted_22 = { class: "form-label" }
const _hoisted_23 = { class: "search-form-item" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "display-flex justify-content-end min-width325px padding20px"
}
const _hoisted_26 = {
  key: 1,
  class: "display-flex justify-content-end min-width325px padding20px",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_27 = { class: "display-flex" }
const _hoisted_28 = { class: "contact-detail-slot" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_import_dialog = _resolveComponent("import-dialog")
  const _component_add_button = _resolveComponent("add-button")
  const _component_face_import_plus = _resolveComponent("face-import-plus")
  const _component_face_import = _resolveComponent("face-import")
  const _component_import_resident = _resolveComponent("import-resident")
  const _component_rf_card_import = _resolveComponent("rf-card-import")
  const _component_circle_tip = _resolveComponent("circle-tip")
  const _component_question_tip = _resolveComponent("question-tip")
  const _component_button_tip = _resolveComponent("button-tip")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_pay_app = _resolveComponent("pay-app")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.projectType==='community')
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$wordList.DeviceDetailDetailUnitName), 1),
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.requestData.param.Build,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestData.param.Build = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_cus_option, {
                        value: "all",
                        label: _ctx.$wordList.SelectAll
                      }, null, 8, ["label"]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item,
                          value: item.key,
                          label: item.value
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$wordList.RDeviceSearchLabelRoomName), 1),
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.requestData.param.Room,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.requestData.param.Room = $event)),
                    filter: ""
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_cus_option, {
                        value: "all",
                        label: _ctx.$wordList.SelectAll
                      }, null, 8, ["label"]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aptOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item,
                          value: item.key,
                          label: item.value
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$wordList.ProperAllTextAccountType), 1),
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.requestData.param.Role,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.requestData.param.Role = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_cus_option, {
                        value: "all",
                        label: _ctx.$wordList.SelectAll
                      }, null, 8, ["label"]),
                      _createVNode(_component_cus_option, {
                        value: "master",
                        label: _ctx.$wordList.PersonuserFamilyMaster
                      }, null, 8, ["label"]),
                      _createVNode(_component_cus_option, {
                        value: "member",
                        label: _ctx.$wordList.NavInHtmlMenuUser2
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$wordList.RDeviceListTanleActive), 1),
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.requestData.param.Active,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.requestData.param.Active = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_cus_option, {
                        value: "all",
                        label: _ctx.$wordList.SelectAll
                      }, null, 8, ["label"]),
                      _createVNode(_component_cus_option, {
                        value: "1",
                        label: _ctx.$wordList.ProperAllTextNormal
                      }, null, 8, ["label"]),
                      _createVNode(_component_cus_option, {
                        value: "2",
                        label: _ctx.$wordList.ProperAllTextInactive
                      }, null, 8, ["label"]),
                      _createVNode(_component_cus_option, {
                        value: "3",
                        label: _ctx.$wordList.ProperAllTextExpiring
                      }, null, 8, ["label"]),
                      _createVNode(_component_cus_option, {
                        value: "4",
                        label: _ctx.$wordList.ProperAllTextExpired
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$wordList.ProperAllTextAppStatus), 1),
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.requestData.param.Status,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.requestData.param.Status = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_cus_option, {
                        value: "all",
                        label: _ctx.$wordList.SelectAll
                      }, null, 8, ["label"]),
                      _createVNode(_component_cus_option, {
                        value: "1",
                        label: _ctx.$wordList.DarshbordRegistered
                      }, null, 8, ["label"]),
                      _createVNode(_component_cus_option, {
                        value: "0",
                        label: _ctx.$wordList.DarshbordUnregistered
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_el_input, {
                    class: "width400px",
                    modelValue: _ctx.requestData.param.searchValue,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.requestData.param.searchValue = $event))
                  }, {
                    prepend: _withId(() => [
                      _createVNode(_component_cus_select, {
                        modelValue: _ctx.requestData.param.searchKey,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.requestData.param.searchKey = $event))
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchKeyList, (item) => {
                            return (_openBlock(), _createBlock(_component_cus_option, {
                              key: item,
                              value: item.name,
                              label: item.label
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ], 64))
            : (_ctx.projectType==='office')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$wordList.ProperAllTextDepartment), 1),
                    _createVNode(_component_cus_select, {
                      modelValue: _ctx.requestData.param.DepartmentID,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.requestData.param.DepartmentID = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_cus_option, {
                          value: "all",
                          label: _ctx.$wordList.SelectAll
                        }, null, 8, ["label"]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_cus_option, {
                            key: item,
                            value: item.key,
                            label: item.value
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$wordList.ProperAllTextIdentity), 1),
                    _createVNode(_component_cus_select, {
                      modelValue: _ctx.requestData.param.Role,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.requestData.param.Role = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_cus_option, {
                          value: "all",
                          label: _ctx.$wordList.SelectAll
                        }, null, 8, ["label"]),
                        _createVNode(_component_cus_option, {
                          value: "30",
                          label: _ctx.$wordList.BasicUser
                        }, null, 8, ["label"]),
                        _createVNode(_component_cus_option, {
                          value: "31",
                          label: _ctx.$wordList.AdvancedUser
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$wordList.RDeviceListTanleActive), 1),
                    _createVNode(_component_cus_select, {
                      modelValue: _ctx.requestData.param.Active,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.requestData.param.Active = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_cus_option, {
                          value: "all",
                          label: _ctx.$wordList.SelectAll
                        }, null, 8, ["label"]),
                        _createVNode(_component_cus_option, {
                          value: "1",
                          label: _ctx.$wordList.ProperAllTextNormal
                        }, null, 8, ["label"]),
                        _createVNode(_component_cus_option, {
                          value: "2",
                          label: _ctx.$wordList.ProperAllTextInactive
                        }, null, 8, ["label"]),
                        _createVNode(_component_cus_option, {
                          value: "3",
                          label: _ctx.$wordList.ProperAllTextExpiring
                        }, null, 8, ["label"]),
                        _createVNode(_component_cus_option, {
                          value: "4",
                          label: _ctx.$wordList.ProperAllTextExpired
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$wordList.ProperAllTextAppStatus), 1),
                    _createVNode(_component_cus_select, {
                      modelValue: _ctx.requestData.param.Status,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.requestData.param.Status = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_cus_option, {
                          value: "all",
                          label: _ctx.$wordList.SelectAll
                        }, null, 8, ["label"]),
                        _createVNode(_component_cus_option, {
                          value: "1",
                          label: _ctx.$wordList.DarshbordRegistered
                        }, null, 8, ["label"]),
                        _createVNode(_component_cus_option, {
                          value: "0",
                          label: _ctx.$wordList.DarshbordUnregistered
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_el_input, {
                      class: "width400px",
                      modelValue: _ctx.requestData.param.searchValue,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.requestData.param.searchValue = $event))
                    }, {
                      prepend: _withId(() => [
                        _createVNode(_component_cus_select, {
                          modelValue: _ctx.requestData.param.searchKey,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.requestData.param.searchKey = $event))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchKeyList, (item) => {
                              return (_openBlock(), _createBlock(_component_cus_option, {
                                key: item,
                                value: item.name,
                                label: item.label
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ], 64))
              : _createCommentVNode("", true),
          _createVNode(_component_cus_button, { onClick: _ctx.searchList }, {
            default: _withId(() => [
              _hoisted_24,
              _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        (_ctx.projectType === 'community' && _ctx.isNew)
          ? (_openBlock(), _createBlock("div", _hoisted_25, [
              _createVNode(_component_import_dialog, { class: "margin-right10px" }),
              _createVNode(_component_add_button, { onClick: _ctx.add }, null, 8, ["onClick"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_26, [
              (_ctx.projectType==='community')
                ? (_openBlock(), _createBlock(_component_face_import_plus, {
                    key: 0,
                    class: "margin-right10px"
                  }))
                : (_openBlock(), _createBlock(_component_face_import, {
                    key: 1,
                    class: "margin-right10px",
                    "need-face-recognition-enrollment-confirm": _ctx.projectType==='office'
                  }, null, 8, ["need-face-recognition-enrollment-confirm"])),
              _createVNode(_component_add_button, { onClick: _ctx.add }, null, 8, ["onClick"]),
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_import_resident),
                _createVNode(_component_rf_card_import)
              ])
            ]))
      ]),
      _createVNode(_component_list_pagination, {
        headers: _ctx.headers,
        requestData: _ctx.requestData,
        update: _ctx.update,
        saveParamInPath: _ctx.saveParamInPath,
        isSaveParamInPathInRow: true,
        showDefaultAction: [],
        action: _ctx.action,
        showCheck: _ctx.enableDeleteAccount,
        deleteMultipleUrl: _ctx.deleteUrl,
        deleteMultipleMessage: _ctx.$wordList.DeleteAptTip
      }, {
        NameSlotHeader: _withId((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getSortRes(
                        _ctx.projectType==='community'?'pmNewComResident':'pmOfficePeople',
                        'Name')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode(_component_question_tip, { placement: "top-start" }, {
              default: _withId(() => [
                _createVNode("div", null, [
                  _createVNode(_component_circle_tip),
                  _createTextVNode(": " + _toDisplayString(_ctx.$wordList.ProperAllTextNormal), 1)
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_circle_tip, { type: "disable" }),
                  _createTextVNode(": " + _toDisplayString(_ctx.$wordList.ProperAllTextInactive), 1)
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_circle_tip, { type: "warning" }),
                  _createTextVNode(": " + _toDisplayString(_ctx.$wordList.ProperAllTextExpired), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode("img", {
              src: _ctx.getSortImg(
                            _ctx.projectType==='community'?'pmNewComResident':'pmOfficePeople',
                            'Name')
            }, null, 8, ["src"])
          ])
        ]),
        RoomNameSlotHeader: _withId((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getSortRes('pmNewComResident', 'Apt')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg('pmNewComResident', 'Apt')
            }, null, 8, ["src"])
          ])
        ]),
        NameSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(data.scope.Name) + " ", 1),
          (_ctx.projectType === 'community')
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (data.scope.Role == 21)
                  ? (_openBlock(), _createBlock(_component_button_tip, {
                      key: 0,
                      color: "#676767"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextMemberAccount), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_button_tip, { key: 1 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextMasterAccount), 1)
                      ]),
                      _: 1
                    }))
              ], 64))
            : (_ctx.projectType === 'office')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (data.scope.Role == 30)
                    ? (_openBlock(), _createBlock(_component_button_tip, {
                        key: 0,
                        color: "#676767"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.BasicUser), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_button_tip, { key: 1 }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.AdvancedUser), 1)
                        ]),
                        _: 1
                      }))
                ], 64))
              : _createCommentVNode("", true),
          _createVNode(_component_circle_tip, {
            class: "margin-left5px",
            type: ['disable', 'success', 'warning'][data.scope.Active]
          }, null, 8, ["type"])
        ]),
        ContactSlot: _withId((data) => [
          _createVNode("div", _hoisted_28, [
            _createVNode("div", null, [
              _createVNode("img", {
                class: "img-size",
                src: require('@/assets/image/phone.png'),
                ref: _ctx.setAllImg
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString(_ctx.filterEmptyCellValue(data.scope.MobileNumber)), 1)
            ]),
            _createVNode("div", null, [
              _createVNode("img", {
                class: "img-size",
                src: require('@/assets/image/email.png'),
                ref: _ctx.setAllImg
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString(_ctx.filterEmptyCellValue(data.scope.Email)), 1)
            ])
          ])
        ]),
        InitializationSlot: _withId((data) => [
          _createTextVNode(_toDisplayString([_ctx.$wordList.DarshbordUnregistered, _ctx.$wordList.DarshbordRegistered][data.scope.Initialization]), 1)
        ]),
        _: 1
      }, 8, ["headers", "requestData", "update", "saveParamInPath", "action", "showCheck", "deleteMultipleUrl", "deleteMultipleMessage"])
    ]),
    (_ctx.isShowPay)
      ? (_openBlock(), _createBlock(_component_pay_app, {
          key: 0,
          mainId: _ctx.parentId,
          id: _ctx.userId,
          onSuccess: _cache[16] || (_cache[16] = ($event: any) => (_ctx.update++)),
          onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isShowPay=false))
        }, null, 8, ["mainId", "id"]))
      : _createCommentVNode("", true)
  ]))
})